import BurgerButton from "@/components/common-components/burger";
import AccountButtons from "@/components/account-buttons";
import { menuItems } from "./menuItems";
import ClickOutside from "vue-click-outside";
import { isClientSide } from "@/common/functions";
import { TRANSPARENT_PNG } from "@/common/consts";
import { mapGetters } from "vuex";

/**
 * NAVIGATION BAR
 *
 * The Navbar Component renders the main navigation for the site using the same
 * markup for large and small devices and requires no Javascript to browse
 * across dropdowns. To achieve that it uses hidden checkboxes as in many pure
 * CSS click Dropdown menus. This approach might be controversial ¯\_(ツ)_/¯
 *
 */
export default {
	name: "Navbar",
	components: {
		BurgerButton,
		AccountButtons,
	},
	data() {
		return {
			header: null,
			currentlyOpenSubMenu: null,
		};
	},
	computed: {
		...mapGetters("device", ["isSmallDevice", "isExtraLargeDevice"]),
		...mapGetters("navigationChecks", ["isPersistentSearch"]),
		menu() {
			if (this.$store.state.device.windowWidth === null) return [];

			if (this.isExtraLargeDevice) {
				return menuItems.slice(0, 4).concat(menuItems.slice(4));
			}

			return menuItems;
		},
		topIndent() {
			const adHeight = !this.isSmallDevice
				? this.$store.state.device.topAdHeight
				: 0;
			let result = adHeight + this.$store.state.device.headerHeight;
			// Take into account that header is 8 px less in height when persistent search element is present
			// Also take into account that persistent search only is applyable on small devices
			if (this.isPersistentSearch && this.isSmallDevice) result += 8;
			return result;
		},
	},
	methods: {
		dispatchGaEvent(item) {
			const eventCategory = "Header";
			const eventLabel = item.gaEventLabel
				? item.gaEventLabel
				: item.labelDictionaryKey;
			const eventActionTranslation = item.gaEventAction
				? item.gaEventAction
				: this.$t(item.labelDictionaryKey);
			const eventAction = item.navLink
				? `Click on ${eventActionTranslation} navigation element`
				: `Click on ${eventActionTranslation} subnavigation element`;
			this.$store.dispatch("trackEvent", {
				eventCategory,
				eventAction: eventAction,
				eventLabel: eventLabel,
				eventID: item.eventID,
			});
		},
		toggleMenu(index = null) {
			if (!this.isExtraLargeDevice) return;
			this.currentlyOpenSubMenu = index;
			this.currentlyOpenSubMenu === null
				? this.header.classList.remove("header-bg")
				: this.header.classList.add("header-bg");
		},
		onItemClick(item, index) {
			if (item.submenu) {
				if (this.currentlyOpenSubMenu === index) {
					this.toggleMenu();
				} else {
					this.toggleMenu(index);
				}
			}
			this.dispatchGaEvent(item);
		},
		onSubMenuClickOutside(e) {
			const el = e.composedPath().find((el) => {
				return (
					typeof el.matches === "function" &&
					(el.matches("[id^='menu']") ||
						el.matches("[id^='submenu']") ||
						el.matches("[id^='pre-menu']"))
				);
			});

			if (el) {
				return;
			}

			this.toggleMenu();
		},
		getImageURL(menuOption) {
			return isClientSide() ? menuOption.imageUrlWebp : "";
		},
		getBackupImageURL(menuOption) {
			return isClientSide() ? menuOption.imageUrl : TRANSPARENT_PNG;
		},
		getMenuId(index) {
			return isClientSide() ? `menu${index}` : `pre-menu${index}`;
		},
		flattenSubMenuItemsForMobile(groups = []) {
			return groups.reduce((acc, i) => {
				if (Array.isArray(i)) {
					return [...acc, ...i];
				}
				return [...acc, i];
			}, []);
		},
		onOutsideMenuClick() {
			this.$store.commit("toggleBurger");
			if (
				!this.$store.state.navigation.burgerActive &&
				this.$refs.submenu
			) {
				for (const item of this.$refs.submenu) {
					item.checked = false;
				}
			}
		},
	},
	mounted() {
		this.header = document.getElementsByClassName("header")[0];
	},
	directives: {
		ClickOutside,
	},
};
